module.exports = __webpack_public_path__ + "static/Map-94b07a52ef59f2df09b287354687cf71.png";